module.exports = __webpack_public_path__ + "fonts/DroidKufi-Bold.1b89eb34.ttf";